module.exports = __webpack_public_path__ + "img/img_left_nav_recommend.a363095f.svg";